/* eslint-disable no-magic-numbers */

/**
 * Base colors. Raw values with no meaning attached. The design system palette, 1:1.
 * Do not reference these in components — use the semantic tokens on the theme.
 */
export const primitives = {
	neutral: {
		0: '#F0F0F0',
		100: '#D6D6D6',
		200: '#BFBFBF',
		300: '#9E9E9E',
		400: '#858585',
		500: '#737373',
		600: '#404040',
		700: '#333333',
		800: '#292929',
		850: '#1F1F1F',
		900: '#121212',
	},
	green: {
		200: '#CEF5CA',
		300: '#9CF995',
		400: '#74F76D',
		500: '#0DF20D',
		600: '#1AB018',
		700: '#137310',
		800: '#003D00',
		900: '#001E00',
	},
	red: {
		200: '#F8D5D3',
		300: '#F5968F',
		400: '#FB5F51',
		500: '#F22821',
		600: '#C00B08',
		700: '#8C0404',
		800: '#570000',
		900: '#310202',
	},
	orange: {
		200: '#F2DCCE',
		300: '#F5C2A0',
		400: '#FBA567',
		500: '#FD8608',
		600: '#BF6612',
		700: '#85460D',
		800: '#572300',
		900: '#2D1605',
	},
	yellow: {
		200: '#F7EEC8',
		300: '#FAE89E',
		400: '#F9E476',
		500: '#FFDA0A',
		600: '#B89E19',
		700: '#7C6A13',
		800: '#4E3504',
		900: '#1E1904',
	},
	blue: {
		200: '#C8D3EC',
		300: '#99B3EF',
		400: '#6790F8',
		500: '#3866FF',
		600: '#1817F7',
		700: '#0B0FA1',
		800: '#0B1241',
		900: '#010223',
	},
	cyan: {
		200: '#CFF1F5',
		300: '#A9EDF5',
		400: '#7EE3EF',
		500: '#0AE6FA',
		600: '#0CA1BE',
		700: '#09627F',
		800: '#022B41',
		900: '#001624',
	},
	violet: {
		200: '#DCD3EE',
		300: '#BBB2F1',
		400: '#A18DF9',
		500: '#8B62FE',
		600: '#6915E3',
		700: '#400D8F',
		800: '#1D0246',
		900: '#070119',
	},
	purple: {
		200: '#E1CFED',
		300: '#D3A6F1',
		400: '#C875F9',
		500: '#BB32FB',
		600: '#9013C5',
		700: '#630E89',
		800: '#38005C',
		900: '#1F052C',
	},
	pink: {
		200: '#F6DAEA',
		300: '#F4B8D8',
		400: '#FA89BC',
		500: '#FA4CA5',
		600: '#CC157F',
		700: '#901058',
		800: '#57053E',
		900: '#32061D',
	},
} as const;
